module.exports = __webpack_public_path__ + "img/television.8b0cfa3f.svg";